module.exports = __webpack_public_path__ + "83952cd78a500bd47b5e9c67934519b8.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/snake.png
// module id = 971
// module chunks = 2